import React, { useEffect, useState } from 'react';
import { AltFieldItem } from 'views/AltFieldMapper.js';
import ListField from 'views/ListField.js';

const ScopeEditor = ({ config, onChange, utils, value }) => {

    const [dataPoint, setDataPoint] = useState(null);
    const [items, setItems] = useState(config?.items || []);
    const [notes, setNotes] = useState(null);
    const [values, setValues] = useState([]);

    const onDataPointChange = item => {
        
        // update local state with new value
        setDataPoint(item?.id);

        // prepare payload for subscribers
        let payload = {
            data_point: item?.id,
            notes: notes,
            values: values
        }

        // notify subscribers that data has changed
        if(typeof(onChange) === 'function') {
            onChange(payload);
        }
    }

    const onNotesChange = text => {

        // update local state with new value
        setNotes(text);

        // prepare payload for subscribers
        let payload = {
            data_point: dataPoint,
            notes: text,
            values: values
        }

        // notify subscribers that data has changed
        if(typeof(onChange) === 'function') {
            onChange(payload);
        }
    }

    const onSelectionChange = items => {
        

        // update local state with new value
        setValues(items);

        // prepare payload for subscribers
        let payload = {
            data_point: dataPoint,
            notes: notes,
            values: items
        }

        // notify subscribers that data has changed
        if(typeof(onChange) === 'function') {
            onChange(payload);
        }
    }

    const getTitle = () => {
        return items.find(item => item.id === dataPoint)?.title || '';
    }

    const shouldShowConfguration = () => {
        return dataPoint === 58; // custom_scope
    }

    useEffect(() => {
        setItems(config?.items || []);
    }, [config]);

    useEffect(() => {
        setDataPoint(value?.data_point);
        setNotes(value?.notes);
        setValues(value?.values || []);
    }, [value]);

    return (
        <div style={{
            display: 'flex',
            flexDirection:' column',
            width: '100%'
        }}>
            <ListField 
            items={items}
            onChange={onDataPointChange} 
            style={{
                marginBottom: 24
            }}
            value={getTitle()} />
            {shouldShowConfguration() === true && (
                <AltFieldItem 
                item={{
                    component: 'multiple_textfield',
                    key: 'custom_plan',
                    onChange: onSelectionChange,
                    props: {
                        placeholder: `Add your custom ${config?.title?.toLowerCase() || 'config'} here...`
                    },
                    title: getTitle(),
                    value: values
                }}
                lastItem={false}
                utils={utils} />
            )}
            <AltFieldItem 
            item={{
                component: 'textview',
                key: 'notes',
                onChange: onNotesChange,
                required: false,
                title: 'Additional Notes or Comments',
                value: notes
            }}
            lastItem={true}
            utils={utils} />
        </div>
    )
}

export default ScopeEditor;
